import React from 'react';
import { translate } from '@utils/i18n';
import Table, { TableSize } from '@components/Table';
import { Loader, LoaderSizes } from '@components/Loader/Loader';
import { namespace } from './constants';
import '../FormLibrary/LocationDisplay.css';
function LongFormTemplatesTable({ templates, isLoading, onClickItem, territories = [] }) {
    const columns = [
        {
            label: translate('headers.name', { namespace }),
            dataKey: 'name'
        },
        {
            label: translate('headers.system_type', { namespace }),
            dataKey: 'displaySystemType'
        },
        ...(territories.length > 0
            ? [
                {
                    label: translate('headers.territories', { namespace }),
                    dataKey: 'territoryIds',
                    renderer: ({ item }) => {
                        var _a;
                        const matched = ((_a = item.territoryIds) === null || _a === void 0 ? void 0 : _a.length)
                            ? territories.filter((t) => item.territoryIds.includes(t.value))
                            : [];
                        if (!matched.length)
                            return React.createElement("span", { className: "location-no-data" }, translate('all_territories', { namespace }));
                        return (React.createElement("div", { className: "location-badges-container" }, matched.map((t) => (React.createElement("span", { key: t.value, className: "location-territory-badge" }, t.label)))));
                    }
                }
            ]
            : []),
        {
            label: translate('headers.active', { namespace }),
            dataKey: 'active',
            renderer: ({ item }) => (React.createElement("span", null, item.active ? translate('active', { namespace }) : translate('inactive', { namespace })))
        },
        {
            label: '',
            dataKey: 'id',
            renderer: ({ item }) => (React.createElement("button", { type: "button", title: translate('headers.edit_details', { namespace }), "aria-label": translate('headers.edit_details', { namespace }), className: "qmb-control--icon", onClick: () => onClickItem(item) },
                React.createElement("i", { className: "fa-light fa-pencil", "aria-hidden": "true" })))
        }
    ];
    if (isLoading) {
        return (React.createElement("div", { className: "loading-center" },
            React.createElement(Loader, { size: LoaderSizes.xlarge })));
    }
    if (templates.length === 0) {
        return React.createElement("div", { className: "no-data-message" }, translate('no_data', { namespace }));
    }
    return React.createElement(Table, { columns: columns, data: templates, size: TableSize.Full, variant: "listing" });
}
export default LongFormTemplatesTable;
